/** Gestão da carteira: rentabilidade estimada por cliente, tempos padrão e satisfação. */
import { createFileRoute } from '@tanstack/react-router';
import { Gestao } from '../telas/gestao/gestao';

export const Route = createFileRoute('/_app/gestao')({ component: Gestao });
